import { Modal } from 'antd';
const { confirm } = Modal;

export function showDeleteConfirm(
  handleDeleteAccount,
  handleDisbaledAccount,
  { showDisableAction = true, cloudAccountName = 'cloudAccountName' } = {}
) {
  confirm({
    closable: true,
    maskClosable: true,
    title: (
      <p
        style={{
          margin: 0,
          fontSize: '1em',
        }}
      >
        {showDisableAction ? (
          <span>
            Delete or Disable
            <b style={{ color: '#1890ff' }}> {cloudAccountName}</b>?
          </span>
        ) : (
          <span>
            Delete
            <b style={{ color: '#1890ff' }}> {cloudAccountName}</b>?
          </span>
        )}
      </p>
    ),
    content: (
      <p
        style={{
          margin: 0,
          fontSize: '0.8em',
        }}
      >
        {showDisableAction ? (
          <span>
            If you do not want to use this cloud account, you can disable it. Once the cloud account
            is deleted, it cannot be retrieved again.
          </span>
        ) : (
          <span>
            Are you sure you want to delete this cloud account? Once the cloud account is deleted,
            it cannot be retrieved again.
          </span>
        )}
      </p>
    ),
    okType: 'danger',
    okText: 'Delete Account',
    cancelText: showDisableAction ? 'Disable Account' : 'Cancel',
    cancelButtonProps: {
      onClick: async () => {
        if (showDisableAction) await handleDisbaledAccount();
        else Modal.destroyAll();
      },
    },
    onCancel() {
      Modal.destroyAll();
    },
    centered: true,
    async onOk() {
      await handleDeleteAccount();
    },
  });
}
